<template>
  <section
    ref="refAICard"
    class="ai-card"
    :class="{'is-list': limit === 0}"
    v-if="showContentList.length || retainItem"
  >
    <a-spin :spinning="spinning">
      <h3
        class="title"
        :class="{'is-hover': limit !== 0}"
        @click.exact="enterList(item)"
        @click.ctrl="openNewTitle(item)"
      >{{item.sectionName}}</h3>
      <ul class="ul-list">
        <li
          :class="['li-item',isILocalizeFn()?'li-item-KNOWLEDGE':'']"
          v-for="(liItem, index) in showContentList"
          :key="liItem.kmContentId"
          @click.exact="seeDetail(liItem, item)"
          @click.ctrl="openNew(liItem, item)"
          :ref="'refLi_' + index"
        >
          <a-tooltip placement="top">
            <template
              slot="title"
              v-if="showToolTips[index]"
            >
              {{liItem.question}}
            </template>
            {{liItem.question}}
          </a-tooltip>
        </li>
      </ul>
      <p
        :class="['see-more',isILocalizeFn()?'see-more-KNOWLEDGE':'']"
        @click.exact="enterList(item)"
        @click.ctrl="openNewTitle(item)"
        v-if="showContentList.length >= limit && limit !== 0"
        v-html="$t('component.aiCard.seeAll', {count: item.contentList.length})">
      </p>
    </a-spin>
  </section>
</template>
<script>
import { dealShowPath } from "@/utils/path.js";
import { throttle } from "@/utils/tool";
export default {
  name: "aiCard",
  inject: ["isILocalizeFn"],
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    limit: {
      type: Number,
      default: 0
    },
    spinning: {
      type: Boolean,
      default: false
    },
    // list为空时依然显示此卡片
    retainItem: {
      type: Boolean,
      default: false
    },
    closeSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showToolTips: [], //是否显示tooltip合集
      // seeAll:$t('component.aiCard.seeAll', {count: item.contentList.length}),//查看全部
    };
  },
  mounted() {
    this.setShowTooltip();
    const resizeFunc = throttle(this.setShowTooltip, 200);
    window.addEventListener("resize", resizeFunc);
  },
  computed: {
    showContentList() {
      let contentList = this.item.contentList || [];
      if (this.limit === 0) return contentList;
      return contentList.slice(0, this.limit);
    }
  },
  
  methods: {
    setShowTooltip() {
      if (this.limit === 0) return;
      let ref = this.$refs.refAICard;
      if (!ref) return;
      this.showToolTips = [];
      let wrapWidth = ref.offsetWidth;
      let liWidth = wrapWidth - 40;
      let list = this.showContentList;
      this.showContentList.forEach((item, index) => {
        let ref = this.$refs["refLi_" + index][0];
        let span = ref.querySelector("span");
        let spanWidth = span.offsetWidth;
        let flag = spanWidth >= liWidth;
        this.showToolTips.push(flag);
      });
    },
    // 查看完整列表
    enterList(item) {
      let path = this.getTitlePath(item);
      if (!path) return;
      this.$router.push({ path });
    },
    // 获取标题链接
    getTitlePath(item) {
      if (this.limit === 0) return;
      let { sectionIdKey, gameIdKey, sectionName } = item;
      let { gameName, page, alias } = this.$route.params;
      gameName = gameName.replace(/\s+/g, "-");
      return `/${gameName}/${page}/${alias}/${gameIdKey}/${sectionIdKey}`;
    },
    openNewTitle(item) {
      let path = this.getTitlePath(item);
      if (!path) return;
      let newLink = this.getFullPath(path);
      window.open(newLink);
    },
    openNew(row, item) {
      let link = this.getPath(row, item);
      let newLink = this.getFullPath(link);
      window.open(newLink);
    },
    getPath(row, item) {
      let { sectionName, gameIdKey, sectionIdKey: sectionIdKeyItem } = item;
      // sectionIdKey = sectionIdKey || row.sectionIdKey;
      let { kmContentIdKey, sectionIdKey: sectionIdKeyRow } = row;
      let sectionIdKey = sectionIdKeyItem || sectionIdKeyRow;
      // :gameName/:page/:alias/:gameIdKey/:sectionIdKey/:kmContentIdKey
      let { gameName, page, alias } = this.$route.params;
      return `/${gameName}/${page}/${alias}/${gameIdKey}/${sectionIdKey}/${kmContentIdKey}`;
    },
    getFullPath(path) {
      let { origin, pathname } = location;
      return origin + pathname + "#" + path;
    },
    // 查看详情
    seeDetail(row, item) {
      let { sectionName, gameIdKey, sectionIdKey: sectionIdKeyItem } = item;
      // sectionIdKey = sectionIdKey || row.sectionIdKey;
      let { kmContentIdKey, sectionIdKey: sectionIdKeyRow } = row;
      let sectionIdKey = sectionIdKeyItem || sectionIdKeyRow;
      // :gameName/:page/:alias/:gameIdKey/:sectionIdKey/:kmContentIdKey
      let { gameName, page, alias } = this.$route.params;
      let path = `/${gameName}/${page}/${alias}/${gameIdKey}/${sectionIdKey}/${kmContentIdKey}`;
      this.$router.push({ path });
      this.$bus.$emit("clear-search");
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/style/media.scss";
@import "~@/style/mixins.scss";
.ai-card {
  // $title-height: 30px;
  $li-height: 27px;
  $ul-height: $li-height * 5;
  $see-more-height: 20px;

  border-radius: 4px;
  color: #303133;
  padding: 20px;
  margin-bottom: 20px;
  min-height: 240px;
  overflow: hidden;
  .title {
    width: 100%;
    // height: $title-height;
    font-size: 24px;
    font-weight: 500;
    display: inline-block;
    @include ellipsis;
    &.is-hover {
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .ul-list {
    height: $ul-height;
    margin-bottom: 0;
    .li-item {
      width: 100%;
      @include ellipsis;
      color: #8d8d8d;
      font-size: 16px;
      cursor: pointer;
      display: inline-block;
      height: $li-height;
      line-height: $li-height;
      &:hover {
        text-decoration: underline;
      }
    }
    .li-item-KNOWLEDGE{
      color: #00bbbb;
    }
  }
  .see-more {
    height: $see-more-height;
    margin-bottom: 0;
    margin-top: 30px;
    color: #409eff;
    text-decoration: underline;
    cursor: pointer;
  }
  .see-more-KNOWLEDGE{
    color: #00bbbb;
  }
  @include media-xs {
    width: 100%;
  }
  @include media-sm {
    width: 48%;
  }
  @include media-md {
    width: 45%;
  }
  @include media-min-md {
    width: 32%;
  }
  &.is-list {
    width: 80%;
    height: auto;
    min-height: none;
    // max-height: 400px;
    // overflow-y: auto;
    /*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
    &::-webkit-scrollbar {
      width: 6px;
      height: 12px;
      background-color: #f5f5f5;
    }
    /*定义滚动条轨道
 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      border-radius: 10px;
      background-color: #f5f5f5;
    }
    /*定义滑块
 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #2ca7db;
    }
    .ul-list {
      height: auto;
      .li-item {
        height: auto;
        overflow: hidden;
        white-space: normal;
      }
    }
    @include media-xs {
      width: 100%;
    }
    @include media-sm {
      width: 100%;
    }
    @include media-md {
      width: 80%;
    }
  }
  &::-webkit-scrollbar-track-piece {
    background-color: rgba(44, 161, 210, 0.33);
    --webkit-border-radius: 6px;
  }
}
</style>